/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetFwSystems200Ok
 */
export interface GetFwSystems200Ok {
    /**
     * contested string
     * @type {string}
     * @memberof GetFwSystems200Ok
     */
    contested: GetFwSystems200OkContestedEnum;
    /**
     * occupier_faction_id integer
     * @type {number}
     * @memberof GetFwSystems200Ok
     */
    occupierFactionId: number;
    /**
     * owner_faction_id integer
     * @type {number}
     * @memberof GetFwSystems200Ok
     */
    ownerFactionId: number;
    /**
     * solar_system_id integer
     * @type {number}
     * @memberof GetFwSystems200Ok
     */
    solarSystemId: number;
    /**
     * victory_points integer
     * @type {number}
     * @memberof GetFwSystems200Ok
     */
    victoryPoints: number;
    /**
     * victory_points_threshold integer
     * @type {number}
     * @memberof GetFwSystems200Ok
     */
    victoryPointsThreshold: number;
}


/**
 * @export
 */
export const GetFwSystems200OkContestedEnum = {
    Captured: 'captured',
    Contested: 'contested',
    Uncontested: 'uncontested',
    Vulnerable: 'vulnerable'
} as const;
export type GetFwSystems200OkContestedEnum = typeof GetFwSystems200OkContestedEnum[keyof typeof GetFwSystems200OkContestedEnum];


/**
 * Check if a given object implements the GetFwSystems200Ok interface.
 */
export function instanceOfGetFwSystems200Ok(value: object): value is GetFwSystems200Ok {
    if (!('contested' in value) || value['contested'] === undefined) return false;
    if (!('occupierFactionId' in value) || value['occupierFactionId'] === undefined) return false;
    if (!('ownerFactionId' in value) || value['ownerFactionId'] === undefined) return false;
    if (!('solarSystemId' in value) || value['solarSystemId'] === undefined) return false;
    if (!('victoryPoints' in value) || value['victoryPoints'] === undefined) return false;
    if (!('victoryPointsThreshold' in value) || value['victoryPointsThreshold'] === undefined) return false;
    return true;
}

export function GetFwSystems200OkFromJSON(json: any): GetFwSystems200Ok {
    return GetFwSystems200OkFromJSONTyped(json, false);
}

export function GetFwSystems200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwSystems200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'contested': json['contested'],
        'occupierFactionId': json['occupier_faction_id'],
        'ownerFactionId': json['owner_faction_id'],
        'solarSystemId': json['solar_system_id'],
        'victoryPoints': json['victory_points'],
        'victoryPointsThreshold': json['victory_points_threshold'],
    };
}

export function GetFwSystems200OkToJSON(json: any): GetFwSystems200Ok {
    return GetFwSystems200OkToJSONTyped(json, false);
}

export function GetFwSystems200OkToJSONTyped(value?: GetFwSystems200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contested': value['contested'],
        'occupier_faction_id': value['occupierFactionId'],
        'owner_faction_id': value['ownerFactionId'],
        'solar_system_id': value['solarSystemId'],
        'victory_points': value['victoryPoints'],
        'victory_points_threshold': value['victoryPointsThreshold'],
    };
}

